import { useQuery } from 'react-query'
import { QueryOptions, Shop } from '../../types'
import { logFactory } from '../../util/logFactory'
import { useAppointmentsService } from '../services'
import { ShopsFilters } from '../services/appointments/shops'

type Query = ShopsFilters

const hookName = 'useShops'
const log = logFactory(hookName)

const useShops = (query: Query, { enabled = true }: QueryOptions) => {
  const { getShops, isReady } = useAppointmentsService()

  const fetchShop = async (): Promise<Shop[]> => {
    log(`🏛️ Fetching shops...`, query)

    const { data: shops } = await getShops(query)

    log(`🏛️ Found shops`, shops)

    return shops
  }

  return useQuery([hookName, query], fetchShop, {
    enabled: Boolean(Object.keys(query).length && isReady && enabled),
  })
}

export { useShops }
